<template>
  <div
    id="choice-by-industry"
    :class="this.$isPC ? '' : 'sp-choice-by-industry'"
  >
    <div class="industry-scene-choice">
      <div v-if="showScenes" class="industry-scene-choice-header for-in-page">
        お客様のご利用シーンに合わせて商品をお選びください。
      </div>
      <div v-else class="industry-scene-choice-header for-in-home">
        <h3><span>様々な業種でご利用いただけます。</span></h3>
      </div>
      <div class="industry-scene-list">
        <router-link
          class="industry-scene"
          v-for="(industry, index) in industries"
          :key="'scene' + index"
          :to="'/choice/industry/' + industry.id"
          v-smooth-scroll="{ duration: 1000, offset: -20 }"
          v-bind:class="[showScenes ? 'for-in-home' : '']"
        >
          <picture>
            <source
              class="industry-scene-image"
              v-bind:srcset="industry.webpPath"
              type="image/webp"
              :alt="industry.shortName + `の呼び出しベル`"
            />
            <img
              class="industry-scene-image"
              v-bind:srcset="industry.imagePath"
              :alt="industry.shortName + `の呼び出しベル`"
            />
          </picture>
          <div class="industry-scene-name">{{ industry.shortName }}</div>
        </router-link>
      </div>
    </div>

    <div v-if="!showScenes" class="industry-list-button-wrap">
      <router-link to="/choice/industry" class="industry-list-button">
        業種一覧を確認する
      </router-link>
    </div>

    <div v-if="showScenes">
      <div
        v-for="(industry, index) in industries"
        :key="'industry' + index"
        :id="'industry' + industry.id"
        class="industry-detail"
      >
        <div class="industry-detail-header">
          <img class="industry-detail-image" v-bind:src="industry.imagePath" />
          <div class="industry-detail-title">
            <p class="industry-detail-name">{{ industry.name }}</p>
            <p class="industry-detail-description">
              {{ industry.description }}
            </p>
          </div>
        </div>
        <div class="industry-detail-body">
          <router-link
            v-for="(productId, index) in industry.productIds"
            :key="index"
            v-bind:to="{
              name: 'ProductType',
              params: {
                name: productMap[productId].name,
                type: 'feature',
              },
            }"
            :class="isPC ? 'candidate-product' : 'sp-candidate-product'"
          >
            <img v-bind:src="productMap[productId].imagePath" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      industries: [
        {
          id: 1,
          shortName: '飲食店',
          name: '飲食店',
          imagePath: '/static/industries/1.png',
          webpPath: '/static/industries/1.webp',
          description: `居酒屋やレストランなど、個人規模から大規模チェーン店まで幅広く対応可能です。`,
          productIds: [8, 4, 5, 6],
        },
        {
          id: 2,
          shortName: 'フードコート',
          name: 'フードコート',
          imagePath: '/static/industries/2.png',
          webpPath: '/static/industries/2.webp',
          description: `お客様にお渡しして、準備が整ったらお呼び出し。
          行列店やテイクアウト専門店にもご利用いただけます。`,
          productIds: [1, 7, 2, 3],
        },
        {
          id: 3,
          shortName: '工場',
          name: '工場',
          imagePath: '/static/industries/3.png',
          webpPath: '/static/industries/3.webp',
          description: `呼び出し、遠隔指示、トラブル回避など、工場現場での様々な用途でお選びいただけます。`,
          productIds: [8, 4, 5, 6, 1, 7, 2, 3],
        },
        {
          id: 4,
          shortName: '病院（薬局）',
          name: '病院（薬局）',
          imagePath: '/static/industries/4.png',
          webpPath: '/static/industries/4.webp',
          description: `会計や受付での呼び出しはもちろん、感染予防のため自動車内で待機されている患者様への
          呼び出しなどにもご利用いただけます。`,
          productIds: [8, 4, 5, 6, 1, 7, 2, 3],
        },
        {
          id: 5,
          shortName: '介護（福祉）',
          name: '介護（福祉）',
          imagePath: '/static/industries/5.png',
          webpPath: '/static/industries/5.webp',
          description: `ご家庭での介護から、老健や特養、グループホーム等でも活躍。
          防水送信機の利用でお風呂場など、幅広くご利用いただけます。`,
          productIds: [8, 4, 5, 6],
        },
        {
          id: 6,
          shortName: '物流倉庫（運輸業）',
          name: '物流倉庫（運輸業）',
          imagePath: '/static/industries/6.png',
          webpPath: '/static/industries/6.webp',
          description: `物流センターや倉庫等、待機場所で荷物の搬入・搬出待ちをしているトラックに
          行き先（ゲート番号等）を指示して呼び出すときに最適です。`,
          productIds: [1, 7, 2, 3],
        },
        {
          id: 7,
          shortName: '焼却場・不燃物処理場',
          name: '焼却場、不燃物処理場、クリーンセンター',
          imagePath: '/static/industries/7.png',
          webpPath: '/static/industries/7.webp',
          description: `ごみの持込者に近隣で待機してもらい順番が来たらご案内することで、施設内の混雑や
          周辺道路の渋滞を緩和することができます。`,
          productIds: [1, 7],
        },
        {
          id: 8,
          shortName: 'イベント・展示会',
          name: 'イベント、展示会、レジャー施設',
          imagePath: '/static/industries/8.png',
          webpPath: '/static/industries/8.webp',
          description: `フェスやお祭りなどのイベントやレジャー施設でお客様の順番待ちの呼び出しに
          ご利用いただけます。`,
          productIds: [1, 7, 2, 3],
        },
        {
          id: 9,
          shortName: '屋外施設',
          name: 'アウトドア・屋外施設',
          imagePath: '/static/industries/9.png',
          webpPath: '/static/industries/9.webp',
          description: `複数のアトラクションを予約したお客様を空きが出たものから順番に誘導でき、
          順番待ち行列の解消に役立ちます。`,
          productIds: [1, 7, 2, 3],
        },
        {
          id: 10,
          shortName: '大規模施設',
          name: '大規模施設（デパート、ショッピングモール、複合施設）',
          imagePath: '/static/industries/10.png',
          webpPath: '/static/industries/10.webp',
          description: `お客様が待ち時間を自由に過ごせるほか、職員・スタッフの連絡ツールとしての
          ご利用も可能です。`,
          productIds: [1, 7],
        },
        {
          id: 11,
          shortName: 'カー用品店',
          name: 'カー用品店、多目的ビル',
          imagePath: '/static/industries/11.png',
          webpPath: '/static/industries/11.webp',
          description: `作業待ちやサービスの順番待ちをしているお客様のご案内やスタッフの連絡ツールとして
          ご利用もいただけます。`,
          productIds: [1, 7, 2, 3],
        },
        {
          id: 12,
          shortName: '教育施設',
          name: '学校（自動車学校、学校、教育施設）',
          imagePath: '/static/industries/12.png',
          webpPath: '/static/industries/12.webp',
          description: `体育館やグラウンドなど、校舎から離れた場所にいる先生や職員にも指示ができ、
          効率化に貢献します。`,
          productIds: [1, 7],
        },
      ],
      productMap: {
        1: {
          id: 1,
          shortName: '',
          name: 'remote-reply-call',
          imagePath: '/static/products/remote-reply-call/industry.png',
        },
        2: {
          id: 2,
          name: 'reply-call',
          imagePath: '/static/products/reply-call/industry.png',
        },
        3: {
          id: 3,
          name: 'reply-call-pc',
          imagePath: '/static/products/reply-call-pc/industry.png',
        },
        4: {
          id: 4,
          name: 'eco-chime',
          imagePath: '/static/products/eco-chime/industry.png',
        },
        5: {
          id: 5,
          name: 'coco-call',
          imagePath: '/static/products/coco-call/industry.png',
        },
        6: {
          id: 6,
          name: 'fact-in-call',
          imagePath: '/static/products/fact-in-call/industry.png',
        },
        7: {
          id: 7,
          name: 'remote-reply-call-pc',
          imagePath: '/static/products/remote-reply-call-pc/industry.png',
        },
        8: {
          id: 8,
          name: 'beyond-ec',
          imagePath: '/static/products/beyond-ec/industry.png',
        },
      },
      showScenes:
        this.$route.name === 'Choice' || this.$route.name === 'Choices',
      isPC: this.$isPC,
    }
  },
}
</script>

<style scoped>
h3 {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  display: unset;
}

#choice-by-industry {
  width: 100%;
}

.industry-scene-choice {
  background-color: rgb(217, 230, 240);
}

.industry-scene-choice-header {
  font-weight: bold;
}

.industry-scene-choice-header.for-in-page {
  font-size: 22px;

  padding: 20px 5% 0 5%;

  text-align: center;

  color: rgb(9, 81, 141);
}

.industry-scene-choice-header.for-in-home {
  padding: 20px 15% 10px 15%;
}

.industry-scene-list {
  display: grid;
  justify-content: center;

  padding: 10px 0 30px;

  grid-template-columns: repeat(4, 210px);
  grid-template-rows: repeat(3, 180px);
  grid-gap: 10px 10px;
}

.sp-choice-by-industry .industry-scene-list {
  padding: 10px 0 20%;

  grid-template-columns: repeat(2, 45%);
  grid-template-rows: repeat(6, 17%);
}

.industry-scene {
  width: 100%;
  text-decoration: none;

  color: #4d4d4d;
  border: 1px solid #eee;
  background-color: #fff;
}

.industry-scene.for-in-home {
  cursor: pointer;
  pointer-events: auto;
}

.industry-scene .industry-scene-image {
  width: 100%;
  height: auto;

  background-color: rgb(217, 230, 240);
}

.industry-scene .industry-scene-name {
  font-size: 14px;
  font-weight: bold;

  text-align: center;
}

.industry-detail {
  margin-top: 30px;
}

.industry-detail-header {
  display: flex;

  height: 150px;
  margin-bottom: 30px;

  color: white;
  background: linear-gradient(rgb(70, 152, 233), rgb(26, 87, 186));
}

.sp-choice-by-industry .industry-detail-header {
  padding: 0 5% 0 5%;
}

.industry-detail-header .industry-detail-image {
  display: inline-block;

  width: 210px;
  height: 100%;
  margin-left: 15%;
}

.sp-choice-by-industry .industry-detail-header .industry-detail-image {
  display: inline-block;

  height: auto;
  margin-left: 0;
}

.industry-detail-header .industry-detail-title {
  display: inline-block;

  height: 100%;

  vertical-align: top;
}

.industry-detail-header .industry-detail-title .industry-detail-name {
  font-size: 22px;
  font-weight: bold;

  margin: 30px 0 -10px 30px;
}

.sp-choice-by-industry .industry-detail-title .industry-detail-name {
  font-size: 1rem;
  vertical-align: middle;
}

.industry-detail-header .industry-detail-title .industry-detail-description {
  font-size: 16px;

  margin: 0 0 0 30px;

  white-space: pre-line;
}

.sp-choice-by-industry .industry-detail-description {
  display: none;
}

.industry-detail-body {
  display: flex;
  flex-wrap: wrap;

  max-width: 900px;
  margin: 0 auto;
}

.industry-detail-body .candidate-product {
  width: auto;
  height: 160px;
  margin: 10px 10px;
}

.industry-detail-body .sp-candidate-product {
  width: auto;
  height: 140px;
  margin: 10px 5px;
}

.industry-detail-body .candidate-product img {
  width: auto;
  height: 100%;
}

.industry-detail-body .sp-candidate-product img {
  width: auto;
  height: 100%;
}

.industry-list-button-wrap {
  display: flex;
  justify-content: center;

  margin-top: 30px;
  padding: 0 5% 30px;
}

.industry-list-button {
  font-size: 18px;
  font-weight: bold;

  display: block;

  width: 100%;
  max-width: 320px;
  padding: 14px 10px;

  text-align: center;
  text-decoration: none;
  letter-spacing: 1px;

  color: #ffffff;
  border-radius: 6px;
  border-bottom: 4px solid rgb(15, 58, 120);
  background-color: rgb(26, 87, 167);
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2);

  transition: opacity 0.3s;
}

.industry-list-button:hover {
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/choice/ChoiceByIndustry.vue